<template>
  <div class="login-container">
    <div class="login-card animate__animated animate__fadeInDown">
      <h2 class="card-title">Login</h2>
      <form @submit.prevent="login">
        <div class="form-group">
          <label for="mail">E-mail</label>
          <input id="mail" v-model="mail" type="mail" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input id="password" v-model="password" type="password" class="form-control" required>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-primary btn-block animate__animated animate__pulse">Login</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import config from '@/routing_map.json'
import axios from 'axios'
import router from "@/router";
import NotificationTemplate from "./Notifications/NotificationTemplate";

export default {
  data() {
    return {
      mail: '',
      password: '',
    };
  },
  methods: {
    login() {
      const app_data = this

      if (this.mail && this.password) {
        const form = new URLSearchParams()
        form.append('mail', app_data.mail)
        form.append('password', app_data.password)
        axios.post(
          `${config.app_url}/login`,
          form,
        ).then(response => {
          if (response.data.success) {
            app_data.notifyVue('top', 'right', "Oturum Açıldı!", "success")
            localStorage.setItem('authorization', response.data.msg.authorization)
            localStorage.setItem('userInfo', JSON.stringify(response.data.msg.userInfo))
            router.push('dashboard')
          } else {
            app_data.notifyVue('top', 'right', response.data.msg, "danger")
          }
        }).catch(error => {
          app_data.notifyVue('top', 'right', error.toString(), "danger")
        })
      } else {
        app_data.notifyVue('top', 'right', 'Lütfen Kullanıcı ve Parola Alanını Doldurun!', "danger")
      }
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000
      });
    },
  },
};
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-50%);
  animation: slideIn 0.5s forwards ease-in-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-title {
  color: #007bff;
  text-align: center;
  margin-bottom: 30px;
}

.form-group label {
  font-weight: 600;
  color: #333;
}

.form-control {
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
}

.btn-primary {
  background-color: #007bff;
  border: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .login-card {
    padding: 20px;
    box-shadow: none;
    border-radius: 0;
  }

  .card-title {
    font-size: 24px;
  }

  .form-control {
    font-size: 14px;
  }

  .btn-primary {
    font-size: 16px;
  }
}
</style>
